exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@use '../../colors';.coreView-root{width:100%;z-index:1;height:100%;overflow-y:hidden}.appFrame{overflow:hidden;display:flex;width:100%;height:100%;flex-direction:column}.coreView-content{min-height:calc(100vh - 100px);position:relative;flex-grow:1;background:'transparent'}.innerContent{margin-top:100px;min-height:calc(100vh - 100px);background-color:var(--background-color);height:100%;overflow:hidden}.innerContentSidebar{margin-top:0;margin-left:250px;min-height:calc(100% - 100px);padding-top:36px;background-color:var(--background-color)}\n", ""]);

// exports
